export function stringArrayToBooleanMap(areaIds: string[]): Record<string, boolean> {
  return areaIds.reduce(
    (acc, areaId) => {
      acc[areaId] = true;
      return acc;
    },
    {} as Record<string, boolean>
  );
}

export function mapObjectBy<T, K extends string>(array: T[], keySelector: (item: T) => K): Record<K, T> {
  return array.reduce(
    (acc, item) => {
      const key = keySelector(item);
      acc[key] = item;
      return acc;
    },
    {} as Record<K, T>
  );
}
